import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { genKey } from "../../../../../../helpers/keys.js";
import * as S from "./styled.js";
export const Highlights = ({ props  })=>{
    const { highlights =[]  } = props ?? {};
    return /*#__PURE__*/ _jsx(S.Aside, {
        children: highlights.map((item, index)=>/*#__PURE__*/ _jsxs(S.Highlight, {
                children: [
                    /*#__PURE__*/ _jsx(S.MenuIcon, {
                        className: `nico-${item.icon}`,
                        icon: item.icon
                    }),
                    /*#__PURE__*/ _jsxs(S.Wrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(S.Title, {
                                children: item.title
                            }),
                            /*#__PURE__*/ _jsx(S.Subtitle, {
                                children: item.subtitle
                            }),
                            item.prominents && /*#__PURE__*/ _jsx(S.Prominents, {
                                icon: item.icon,
                                children: item.prominents.map((prominent, index)=>/*#__PURE__*/ _jsxs(S.List, {
                                        children: [
                                            /*#__PURE__*/ _jsx(S.Check, {
                                                className: `nico-check`
                                            }),
                                            prominent
                                        ]
                                    }, genKey({
                                        prominent,
                                        index
                                    })))
                            })
                        ]
                    })
                ]
            }, genKey({
                item,
                index
            })))
    });
};
export default Highlights;

//# sourceMappingURL=index.js.map